export default __webpack_public_path__ + "static/media/Springs.a7bcedca.webp";